/**
 * Omvägs-semantik — kärnan i produkten (designspec §3).
 * Trösklar är konstanter, medvetet förberedda för framtida personlig
 * omvägstolerans (en preferens kan senare mata dessa värden utan omskrivning).
 */

export const DETOUR_ON_ROUTE_MAX = 5; // ≤ 5 min: "i princip på vägen"
export const DETOUR_RED_MIN = 16; // ≥ 16 min: stor omväg (röd)
export const DETOUR_MAX = 30; // > 30 min: filtreras bort (som prototypen)

export type DetourClass = 'on-route' | 'detour' | 'far';

export function classifyDetour(minutes: number): DetourClass {
  if (minutes <= DETOUR_ON_ROUTE_MAX) return 'on-route';
  if (minutes < DETOUR_RED_MIN) return 'detour';
  return 'far';
}

/** Visuell variant: neutral pill för on-route/detour, röd för far. */
export function detourIsRed(minutes: number): boolean {
  return classifyDetour(minutes) === 'far';
}

/** Pill-/etikett-text enligt §3-tabellen. Använder hårt mellanslag före "min". */
export function detourLabel(minutes: number): string {
  if (classifyDetour(minutes) === 'on-route') {
    return `På vägen · +${minutes} min`;
  }
  return `+${minutes} min omväg`;
}

/** Kort form för kartnål: "+8". */
export function detourPinLabel(minutes: number): string {
  return `+${minutes}`;
}
